import { AuthenticationRequirement } from 'src/constants/authenticationRequirement';
import { useHandleAuthenticationRequirment } from 'src/hooks/useHandleAuthenticationRequirment';
import { useAppSelector } from 'src/store/reducers';

import { shouldFormBeDisplayedAsStepView } from '../stepView/utils';

export enum CustomFormButtonType {
  standardView = 'standardView',
  standardStepView = 'standardStepView',
  microwebStandardView = 'microwebStandardView',
  microwebStandardStepView = 'microwebStandardStepView',
  microwebStepView = 'microwebStepView',
  microwebOppgaveView = 'microwebOppgaveView',
  loginButton = 'loginButton',
  ingen = 'ingen',
}

export const useCustomFormButtonType = (): CustomFormButtonType => {
  const formDefinition = useAppSelector(state => state.refero.form.FormDefinition);
  const { isMicroweb, isMicrowebStep, isMicrowebOppgave } = useAppSelector(state => state.microweb);
  const { authenticationRequirement, isAuthorized } = useHandleAuthenticationRequirment();
  const isStepView = shouldFormBeDisplayedAsStepView(formDefinition);
  const loginRequired =
    (authenticationRequirement === AuthenticationRequirement.Required || !authenticationRequirement) && !isAuthorized() && !isMicroweb;

  if (loginRequired) {
    return CustomFormButtonType.loginButton;
  } else {
    if (!isStepView && !isMicroweb) {
      return CustomFormButtonType.standardView;
    }
    if (isStepView && !isMicroweb) {
      return CustomFormButtonType.standardStepView;
    }
    if (isMicroweb && !isStepView && !isMicrowebStep && !isMicrowebOppgave) {
      return CustomFormButtonType.microwebStandardView;
    }
    if (isMicroweb && isStepView && !isMicrowebStep && !isMicrowebOppgave) {
      return CustomFormButtonType.microwebStandardStepView;
    }
    if (isMicroweb && isMicrowebStep) {
      return CustomFormButtonType.microwebStepView;
    }
    if (isMicroweb && isMicrowebOppgave) {
      return CustomFormButtonType.microwebOppgaveView;
    }
  }

  return CustomFormButtonType.ingen;
};
